import React, { useState, useEffect } from "react";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { useLoading } from '../Utils/LoadingContext';

const PlanVSActual = () => {

    const empcode = localStorage.getItem('empcode');
    const { setLoading } = useLoading();

    const [plants, setPlants] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [showSaveButton, setShowSaveButton] = useState(false);

    const [filters, setFilters] = useState({
        CompanyName: "",
        PlantName: "",
        MonthYear: ""
    });

    useEffect(() => {
        loadDropdowns();
    }, []);

    const loadDropdowns = async () => {
        try {
            const [plantRes, companyRes] = await Promise.all([
                EmployeeProcessService.getPlant(empcode),
                EmployeeProcessService.getCompany("User"),
            ]);

            if (plantRes?.data?.statusCode === 200) setPlants(plantRes.data.result);
            if (companyRes?.data?.statusCode === 200) setCompanies(companyRes.data.result);

        } catch (error) {
            console.error("Error loading dropdowns:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    // --------------------- Load Plan -------------------------
    const loadPlanData = async () => {
        if (!filters.PlantName || !filters.MonthYear) {
            alert("Please select  Plant and Month.");
            return;
        }
debugger;
        setLoading(true);
        try {
            const res = await EmployeeProcessService.getPlan(
                filters.PlantName,
                filters.MonthYear
            );

            if (res?.data?.statusCode === 200) {

                const data = res.data.result.map(d => ({
                    departmentID: d.departmentID,
                    departmentName: d.departmentName,
                    mpPlan: d.mpPlan ?? 0
                }));

                setDepartmentList(data);
                setShowSaveButton(true);
            }

        } catch (err) {
            console.error("Error loading plan:", err);
        } finally {
            setLoading(false);
        }
    };

    // --------------------- Update Table Values ------------------
    const updateMPPlan = (index, value) => {
        const updated = [...departmentList];
        updated[index].mpPlan = value;
        setDepartmentList(updated);
    };

    // --------------------- Save Plan ----------------------------
    const savePlan = async () => {

        const payload = {
            plantID: parseInt(filters.PlantName),
            monthYear: filters.MonthYear,
            planData: departmentList.map(d => ({
                departmentID: parseInt(d.departmentID),
                mpPlan: parseInt(d.mpPlan || 0)
            }))
        };

        setLoading(true);
        const res = await EmployeeProcessService.setPlan(payload);
        setLoading(false);

        if (res.success) {
            alert("Plan saved successfully!");
        } else {
            alert("Failed to save plan!");
        }
    };

    return (
        <div className="container mt-3">

            <h4 className="text-primary mb-3">Plan VS Actual</h4>

            <div className="row mb-3">

                {/* <div className="col-md-3">
                    <label className="text-primary">Company</label>
                    <select
                        className="form-select"
                        name="CompanyName"
                        value={filters.CompanyName}
                        onChange={handleChange}
                    >
                        <option value="">Select Company</option>
                        {companies.map(c =>
                            <option key={c.id} value={c.id}>{c.name}</option>
                        )}
                    </select>
                </div> */}

                <div className="col-md-3">
                    <label className="text-primary">Plant</label>
                    <select
                        className="form-select"
                        name="PlantName"
                        value={filters.PlantName}
                        onChange={handleChange}
                    >
                        <option value="">Select Plant</option>
                        {plants.map(p =>
                            <option key={p.id} value={p.id}>{p.name}</option>
                        )}
                    </select>
                </div>

                <div className="col-md-3">
                    <label className="text-primary">Month / Year</label>
                    <input
                        type="month"
                        className="form-control"
                        name="MonthYear"
                        value={filters.MonthYear}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-3 mt-4">
                    <button className="btn btn-primary" onClick={loadPlanData}>
                        Submit
                    </button>
                   
                </div>
                 {showSaveButton && (
                        <div className="col-md-3 mt-4">
                    <button className="btn btn-success" onClick={savePlan}>
                        Save Plan
                    </button>
                    </div>
                )}
            </div>

            {/* TABLE */}
            {departmentList.length > 0 && (
                <>
                    <div className="table-responsive mt-3">
                        <table className="table table-bordered">
                            <thead className="table-dark">
                                <tr>
                                    <th>Department ID</th>
                                    <th>Department Name</th>
                                    <th>MP Plan</th>
                                </tr>
                            </thead>

                            <tbody>
                                {departmentList.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.departmentID}</td>
                                        <td>{item.departmentName}</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={item.mpPlan}
                                                onChange={(e) =>
                                                    updateMPPlan(index, e.target.value)
                                                }
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>


                </>
            )}

        </div>
    );
};

export default PlanVSActual;
